import { CollectionCountResult, OfCollectionsService } from '@api'
import { attach, createEffect, createStore, sample } from 'effector'
import { matchPath } from 'react-router'

import { Pages } from '@/consts/routes'
import { handleError } from '@/utils/error'

import { $creatorId } from './creators'
import { initializeApp } from './init'
import { $currentPage } from './router'

export const getOfCollectionsCountFx = attach({
  name: 'get of collections count',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (_: void, { creatorId }) => ({
    creatorId: creatorId!,
  }),
  effect: createEffect(OfCollectionsService.getCount),
})

getOfCollectionsCountFx.failData.watch((error) => {
  handleError(
    error,
    'Something went wrong while getting collections count',
    getOfCollectionsCountFx,
  )
})

export const $ofCollectionsCount = createStore<CollectionCountResult | null>(
  null,
).on(getOfCollectionsCountFx.doneData, (_, count) => count)

sample({
  clock: [initializeApp, $currentPage],
  source: { path: $currentPage },
  filter: ({ path }) => {
    return !!matchPath(Pages.CHATTING_UI, path)
  },
  target: getOfCollectionsCountFx,
})
